import React, { useEffect, useRef, useState } from 'react';

import {
  addEventListener,
  location,
  removeEventListener,
  window,
} from '../src/env/browser';
import { useGlobals } from '@shared/contexts/GlobalsContext';

import useCreateAppConfig from './use-create-app-config';
import {
  containerStyle,
  iframeStyle,
  MICRO_APP_STARTUP_MESSAGE,
  MICRO_APP_URL,
} from './constants';

const APP_NAME = 'appointment-v4';

const HASH_PREFIX = `#/${APP_NAME}/`;

// Rendered when the page is opened without a hash, so the drawer is never blank.
const DEFAULT_HASH = `${HASH_PREFIX}new`;

/**
 * app-shell routes on the pathname (`createBrowserRouter`), so the hash is the
 * micro-app's, exactly as in production.
 */
export function appHashFrom(hash) {
  return hash?.startsWith(HASH_PREFIX) ? hash : DEFAULT_HASH;
}

export function AppointmentV4App() {
  const deps = useGlobals();
  const iframeRef = useRef(null);
  const [appHash, setAppHash] = useState(() => appHashFrom(location.hash));
  const { isLoading, config } = useCreateAppConfig(APP_NAME, deps);

  useEffect(() => {
    const onHashChange = () => setAppHash(appHashFrom(location.hash));
    addEventListener('hashchange', onHashChange);
    return () => removeEventListener('hashchange', onHashChange);
  }, []);

  useEffect(() => {
    if (iframeRef.current && !isLoading) {
      setTimeout(() => {
        window.Shore.microAppArgs[APP_NAME] = {
          ...config,

          // The playground mounts at `/`, which would leave `/appointment-v4`
          // in the hash for the app's own HashRouter to match against.
          mountPath:
            config?.mountPath && config.mountPath !== '/'
              ? config.mountPath
              : `/${APP_NAME}`,
        };
        iframeRef.current.contentWindow.postMessage(
          { type: MICRO_APP_STARTUP_MESSAGE },
          '*'
        );
      }, 1000);
    }
  }, [iframeRef.current, isLoading, appHash]);

  return (
    <div style={containerStyle}>
      <iframe
        key={appHash}
        id="micro-appointment-v4-app"
        title="AppointmentV4App"
        ref={iframeRef}
        style={iframeStyle}
        src={`${MICRO_APP_URL}/${APP_NAME}/${appHash}`}
      />
    </div>
  );
}
